import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import * as actions from "../../../store/slices/AssessmentSlice";

const useAIAssessmentWrapper = () => {
    const [selectedAssessment, setSelectedAssessment] = useState<any>(null);

  const {
    aiAssessmentsDone: { isLoading, errors, data },
  } = useSelector((state: RootState) => state.assessment);
  const { patientDetails } = useSelector((state: RootState) => state.patient);
  const dispatch = useDispatch();

  useEffect(() => {
    const patientId = patientDetails?.data?.patient_id;
    if (patientId) {
      dispatch(
        actions.getAIAssessmentsDoneRequest({
          patient_id: patientId,
        })
      );
    }
  }, [patientDetails?.data?.patient_id]);

  const handleOnChange = (value: any, option: any) => {
    setSelectedAssessment(option);
  };

  useEffect(() => {
    if (data.length > 0) {
      setSelectedAssessment(data[0]);
    }
  }, [data]);

  return {
    data,
    errors,
    patientDetails,
    selectedAssessment,
    handleOnChange,
    isLoading: isLoading || patientDetails?.isLoading,
  };
}

export default useAIAssessmentWrapper;